import {FC} from 'react'
import {toAbsoluteUrl} from '_metronic/helpers'
import lowerCase from 'lodash/lowerCase'
import capitalize from 'lodash/capitalize'
import SVG from 'react-inlinesvg'

interface Props {
  paymentMethod: any
  title?: string
}

const PaymentMethod: FC<Props> = ({paymentMethod, title}) => {
  if (paymentMethod && paymentMethod.id) {
    const path = lowerCase(paymentMethod.card?.brand)
    return (
      <div className='mb-3'>
        {title && <div className='fs-5 fw-bolder pb-2'>{title}</div>}
        <span>
          <SVG
            id={path}
            src={toAbsoluteUrl(`/media/icons/corksy/payment/${path}.svg`)}
            className='svg-icon-2hx me-2'
          />
          {capitalize(paymentMethod.card?.brand)} ending in {paymentMethod.card?.last4}
        </span>
      </div>
    )
  }
  return null
}

export default PaymentMethod
